import React, { Component } from "react";
import DeleteDialog from "../../../components/DeleteDialog";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";
import { languages } from "../../../constants/languages";

class DeleteDiaSpotContainer extends Component {
  state = {
    open: false,
    errorMessage: "",
  };

  toggleDialog = () => {
    this.setState({ open: !this.state.open, errorMessage: "" });
  };

  handleDelete = () => {
    this.toggleDialog();
    const tournamentRef = window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);

    if (this.props.structureElement.isSponsors) {
      let toUpdate = {};
      let sponsorNum = this.props.structureElement.sponsorNum;
      toUpdate["sponsorIndex" + sponsorNum] = null;
      toUpdate["sponsorGroup" + sponsorNum] = null;
      tournamentRef.collection("dias").doc(this.props.dia.id).update(toUpdate);
    } else if (this.props.structureElement.isText) {
      let toUpdate = {};
      let textNum = this.props.structureElement.textNum;
      toUpdate["diaTextIndex" + textNum] = null;
      toUpdate["diaTextTitle" + textNum] = null;
      toUpdate["diaText" + textNum] = null;
      tournamentRef.collection("dias").doc(this.props.dia.id).update(toUpdate);
    } else if (this.props.structureElement.isPicture) {
      let toUpdate = {};
      let photoNum = this.props.structureElement.photoNum;
      toUpdate["diaPhotoIndex" + photoNum] = null;
      toUpdate["diaPhotoTitle" + photoNum] = null;
      toUpdate["diaPhotoURL" + photoNum] = null;

      tournamentRef.collection("dias").doc(this.props.dia.id).update(toUpdate);
    } else if (this.props.structureElement.isQRCode) {
      tournamentRef
        .collection("dias")
        .doc(this.props.dia.id)
        .update({ qrCodeIndex: null });
    } else if (this.props.structureElement.isDressingRooms) {
      let divisionId =
        this.props.structureElement.divisionId === "0"
          ? ""
          : this.props.structureElement.divisionId;
      let toUpdate = {};
      toUpdate[
        "diaDressingRoomIndex" +
          divisionId +
          this.props.structureElement.layoutNum.toString()
      ] = null;
      tournamentRef.collection("dias").doc(this.props.dia.id).update(toUpdate);
    } else if (this.props.structureElement.isTeamLayouts) {
      let divisionId =
        this.props.structureElement.divisionId === "0"
          ? ""
          : this.props.structureElement.divisionId;
      let toUpdate = {};
      toUpdate[
        "diaTeamLayoutIndex" +
          divisionId +
          this.props.structureElement.layoutNum.toString()
      ] = null;
      tournamentRef.collection("dias").doc(this.props.dia.id).update(toUpdate);
    } else if (this.props.structureElement.isUpcomingMatches) {
      let toUpdate = {};
      toUpdate[
        "diaUpcomingMatchesIndex" + this.props.structureElement.sportParkId
      ] = null;
      tournamentRef.collection("dias").doc(this.props.dia.id).update(toUpdate);
    } else if (this.props.structureElement.isRecentResults) {
      let toUpdate = {};
      toUpdate[
        "diaRecentResultsIndex" + this.props.structureElement.sportParkId
      ] = null;
      tournamentRef.collection("dias").doc(this.props.dia.id).update(toUpdate);
    } else if (this.props.structureElement.isRanking) {
      let toUpdate = {};
      toUpdate[
        "diaRankingIndex" +
          this.props.structureElement.divisionId +
          this.props.structureElement.rankingNum
      ] = null;
      tournamentRef.collection("dias").doc(this.props.dia.id).update(toUpdate);
    } else if (this.props.structureElement.isPlayerStats) {
      let toUpdate = {};
      toUpdate[
        "diaPlayerStatsIndex" +
          this.props.structureElement.divisionId +
          "_" +
          this.props.structureElement.statKey
      ] = null;
      tournamentRef.collection("dias").doc(this.props.dia.id).update(toUpdate);
    } else {
      let toUpdate = {};
      let keyName = "dia";
      if (this.props.structureElement.diaNum !== undefined) {
        keyName += this.props.structureElement.diaNum.toString();
      }
      toUpdate[keyName] = null;
      tournamentRef
        .collection(this.props.elementType)
        .doc(this.props.elementId)
        .update(toUpdate);
    }
  };

  render() {
    return (
      <div>
        <IconButton
          aria-label="Change"
          onClick={this.toggleDialog}
          style={{ height: 30, width: 30 }}
          disabled={this.props.dia.isPSD}
        >
          <DeleteIcon
            style={{ height: 20, width: 20, position: "absolute", top: 6 }}
          />
        </IconButton>
        <DeleteDialog
          open={this.state.open}
          toggleDialog={this.toggleDialog}
          handleDelete={this.handleDelete}
          errorMessage={this.state.errorMessage}
          title={languages.present.removeFromDia}
          description={languages.present.deleteFromDiaWarning}
        />
      </div>
    );
  }
}

export default DeleteDiaSpotContainer;
